<template>
    <modal :show="true"
           @close="close()"
           :id="utils.randomId({prefix: 'modal'})">
        <template #title>
            Invite User
        </template>

        <div v-for="org in user_organizations" class="mb-3 pb-3 border-bottom">
            <div class="mb-2">Invite to join <strong>{{ org.name }}</strong>.</div>
            <div class="d-flex">
                <div class="flex-grow-1 mr-2">
                    <input type="text" :value="shareLink(org)" class="form-control" readonly>
                </div>
                <div class="flex-grow-0">
                    <button class="btn btn-primary"
                            @click="helpers.clipboard.copy( shareLink(org) )">Copy Invite Link</button>
                </div>
            </div>
        </div>

        <div>
            <div class="mb-2">
                Invite to join this platform
            </div>
            <div class="d-flex">
                <div class="flex-grow-1 mr-2">
                    <input type="text" :value="shareLink()" class="form-control" readonly>
                </div>
                <div class="flex-grow-0">
                    <button class="btn btn-primary"
                            @click="helpers.clipboard.copy( shareLink() )">Copy Invite Link</button>
                </div>
            </div>
        </div>

        <template #footer>
            <button class="btn btn-dark" @click="close()">Done</button>
        </template>
    </modal>
</template>

<script>
import Modal from "@/Components/Common/Modal";
import utils from "@/mixins/utils";
import Button from "@/Jetstream/Button";
import helpers from "@/mixins/helpers";

export default {
    name: "InvitationModal",
    components: {Button, Modal},
    mixins: [utils, helpers],
    emits: ['close'],

    methods: {
        close(){
            this.$emit('close');
        },

        shareLink(org = null){
            const params = {...this.global_url_params};
            if( org ) params.organization_id = org.id ?? null;
            return this.route('register', params);
        }
    }

}
</script>

<style scoped>

</style>
